<div style="height: 85vh" id="splash-index">
    <div class="h-100 d-flex justify-content-center align-items-center">
        <div class="contact-container text-center">
            <p class="contact-tel"><a href="tel:07850020019"><i class="fa fa-phone"></i>&nbsp;07850020019</a></p>
            <p class="contact-email"><a href="mailto:bakerswedding2027@gmail.com"><i class="fa fa-envelope"></i>&nbsp;bakerswedding2027&#64;gmail.com</a></p>
        </div>
    </div>
</div>
